import { useEffect, useState } from 'react';
import { NWClient } from '../../../client/NWClient';
import { AIAssistModel } from '../../../models/ai.assist.model';
import { useSearchParams } from 'react-router-dom';
import {
  setCurrentDocumentAISummary,
  resetCurrentDocumentAISummary,
} from '../../../slices/current-document-ai-summary/currentDocumentAISummarySlice';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { RootState } from '../../../store';
import { useAppSelector } from '../../../common/hooks/useAppSelector';

export const useAISummary = (id?: number, allowGettingAISummary?: boolean) => {
  const dispatch = useAppDispatch();
  const currentDocumentAISummary = useAppSelector(
    (state: RootState) => state.currentDocumentAISummary.summary
  );

  const [params] = useSearchParams();
  const generateSummary = params.get('generateSummary');
  const [summary, setSummary] = useState<string>('');
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const [aiSummaryCreationMode, setAISummaryCreationMode] = useState<boolean>(false);
  useEffect(() => {
    if (
      id &&
      allowGettingAISummary &&
      !currentDocumentAISummary &&
      currentDocumentAISummary !== undefined
    ) {
      setPendingStatus(true);
      NWClient.get('ai-assist', id)
        .then((res: AIAssistModel) => {
          if (res.content[0] !== '[') {
            setSummary(res.content);
            dispatch(setCurrentDocumentAISummary(res));
          } else {
            setAISummaryCreationMode(true);
          }
        })
        .finally(() => setPendingStatus(false));
    }
  }, [id, allowGettingAISummary, currentDocumentAISummary, dispatch]);

  useEffect(() => {
    if (generateSummary) {
      setAISummaryCreationMode(true);
    }
  }, [generateSummary]);

  useEffect(() => {
    return () => {
      dispatch(resetCurrentDocumentAISummary());
    };
  }, [dispatch]);

  return {
    summary,
    setSummary,
    pendingStatus,
    aiSummaryCreationMode,
    setAISummaryCreationMode,
  };
};
